var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topup-form"},[_c('div',{staticClass:"topup-form-frame"},[_c('div',{staticClass:"user-data"},[_c('h1',[_vm._v(_vm._s(_vm.$t('view.userData.header')))]),_c('user-data-account'),_c('user-data-payment')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }